module.exports = __webpack_public_path__ + "static/img/zsk-qrcode.4f84a79.jpg";